import { SelectOrderText } from "constants/text";
import { models } from "types/api/viewModels";
import { mixed, object, ObjectSchema } from "yup";

export interface TruckOrderSchemaProps {
	order: models["DraftOrderViewModel"];
}

export const truckOrderSchemaObj = {
	order: mixed<models["DraftOrderViewModel"]>().required(SelectOrderText)
};

export const truckOrderSchema: ObjectSchema<TruckOrderSchemaProps> = object(truckOrderSchemaObj);
